import { useNow } from '../../hooks/useNow';
import { useSettings } from '../../store/settings';

export function Clock({ size = 'lg' }: { size?: 'md' | 'lg' | 'xl' }) {
  const { hour12, showSeconds, timeZone, showDate } = useSettings((s) => s.clock);
  const now = useNow(showSeconds ? 'second' : 'minute');
  const tz = timeZone || undefined;

  let time: string;
  let date: string;
  try {
    time = new Intl.DateTimeFormat(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      second: showSeconds ? '2-digit' : undefined,
      hour12,
      timeZone: tz,
    }).format(now);
    date = new Intl.DateTimeFormat(undefined, { weekday: 'long', day: 'numeric', month: 'long', timeZone: tz }).format(now);
  } catch {
    // Invalid time zone typed in settings – fall back to local time.
    time = now.toLocaleTimeString();
    date = now.toLocaleDateString();
  }

  const timeClass = { md: 'text-5xl', lg: 'text-7xl md:text-8xl', xl: 'text-8xl md:text-[10rem]' }[size];

  return (
    <div className="text-shadow select-none">
      <div className={`${timeClass} font-light leading-none tracking-tight tabular-nums`}>{time}</div>
      {showDate && <div className="mt-2 text-xl font-normal opacity-90 md:text-2xl">{date}</div>}
      {tz && <div className="muted mt-1 text-sm">{tz.replace(/_/g, ' ')}</div>}
    </div>
  );
}
